enum SplitFeature {
  NewDocumentMetadataApi = 'NEW_DOCUMENT_METADATA_API',
  ThirdPartyAccess = 'THIRD_PARTY_ACCESS',
  ModernInboxApi = 'PDMS_MODERN_INBOX_API',
}

export { SplitFeature };
